import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AnyAction } from 'redux';
import { ThunkDispatch } from 'redux-thunk';
import { BasketDetails } from 'shared-types/Basket';
import { Property } from 'shared-types/Property';
import { updateBasket } from '@store/basket/actions';
import { basketSelectors } from '@store/basket/selectors';
import { entitySelectors } from '@store/entity/selectors';
import { removeBasketItem } from '../utils/removeBasketItem';

type AppState = { basket: { basketDetails: BasketDetails } } & Record<string, unknown>;

export const useRemoveBasketItem = (language: string) => {
  const dispatch = useDispatch<ThunkDispatch<AppState, unknown, AnyAction>>();
  const property = useSelector(entitySelectors.getProperty) as Property;
  const basketDetails = useSelector(basketSelectors.getBasketDetails) as BasketDetails;

  return useCallback(
    (id: string) => {
      if (!basketDetails || !property) return;
      if (!Array.isArray(basketDetails.items)) return;
      const remaining = removeBasketItem(basketDetails.items, id);
      dispatch(
        updateBasket(
          property.id,
          basketDetails.id,
          language,
          { promoCode: basketDetails.promoCode, items: remaining },
          true
        )
      );
    },
    [basketDetails, property, language, dispatch]
  );
};
